import remoteConfig from "@react-native-firebase/remote-config";

export const fetchConfig = async () => {
  try {
    await remoteConfig().setConfigSettings({
      isDeveloperModeEnabled: __DEV__,
      // minimumFetchIntervalMillis: 0,
    });
    await remoteConfig().setDefaults({
      allow_notifications_card_screen: false,
    });

    const remote = await remoteConfig().fetchAndActivate();
  } catch (error) {
    console.log({ error });
  }
};

export const refreshConfig = async () => {
  try {
    await remoteConfig().fetch();
  } catch (error) {
    console.log(error);
  }
};

export const getRemoteValue = key => remoteConfig().getValue(key);
